<card name="Users table">
  <div card content>
    <smart-table [headers]="headers" [source]="source" [navigate]="['/user', ':id']">
      <ng-template smartTableColumn="account" let-item>
        <td>
          <span class="font-weight-medium">{{ item.id }}</span> <br>

          <ng-container *ngIf="item.active; else notActive">
            <a class="small" routerLink="/">{{ item.email }}</a>
          </ng-container>
          <ng-template #notActive>
            <small class="text-muted">{{ item.email }}</small>
          </ng-template>
        </td>
      </ng-template>

      <ng-template smartTableColumn="store" let-item>
        <td>
          {{ item.store.name }} <br>
          <small class="text-muted">{{ item.store.id }}</small>
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="info" let-item>
        <td>
          {{ item.info }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="coins" let-item>
        <td>
          <a routerLink="/">Show dynamics</a>
        </td>
      </ng-template>

      <ng-template smartTableColumn="authAt" let-item>
        <td>
          {{ item.authAt | moment }}
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
